import { ArrowRight } from "lucide-react";
import { IMAGES } from "../../data/site";
import { useLang } from "../../i18n/LangContext";
import { useSite } from "../../context/SiteContext";
import { fileUrl } from "../../lib/api";
import { Eyebrow, useChannels } from "./Brand";
import { Particles } from "./Effects";

export const Hero = ({ onJoin }) => {
  const { hero: t } = useLang().t;
  const { site } = useSite();
  const CHANNELS = useChannels();
  return (
  <section id="top" className="relative overflow-hidden">
    <img src={t.image ? fileUrl(t.image, site?.performance?.cdn_base_url) : IMAGES.hero} alt="DaddyAnna247 cricket and casino" data-testid="hero-image" className="absolute inset-0 h-full w-full object-cover object-right opacity-70" />
    <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A] via-[#0A0A0A]/85 to-transparent" />
    <Particles testid="hero-particles" />
    <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-[#0A0A0A] to-transparent" />
    <div className="relative mx-auto max-w-7xl px-4 pb-28 pt-24 sm:px-6 md:pt-36 lg:px-8">
      <div className="max-w-2xl">
        <div className="fade-up"><Eyebrow>{t.eyebrow}</Eyebrow></div>
        <h1 className="fade-up d1 mt-6 font-serif text-4xl font-extrabold uppercase leading-tight text-white sm:text-5xl lg:text-6xl" data-testid="hero-title">
          {t.h1a} <span className="gold-text">{t.h1gold}</span><br />{t.h1b}
        </h1>
        <p className="fade-up d2 mt-6 max-w-xl text-base text-zinc-300 md:text-lg" data-testid="hero-sub">{t.sub}</p>
        <div className="fade-up d3 mt-10 flex flex-wrap gap-4">
          <button onClick={onJoin} data-testid="hero-get-id-button" className="btn-gold group">
            {t.cta} <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
          </button>
          <a href="#how" data-testid="hero-how-link" className="btn-outline">{t.how}</a>
        </div>
        <div className="fade-up d4 mt-10 flex flex-wrap items-center gap-3">
          <span className="text-xs uppercase tracking-widest text-zinc-500">{t.connect}</span>
          {CHANNELS.map((c) => (
            <a key={c.key} href={c.href} target="_blank" rel="noreferrer" data-testid={`hero-${c.key}-cta`}
              className="glass flex items-center gap-2 rounded-full border border-[#D4AF37]/30 px-4 py-2 text-sm text-white transition-colors hover:border-[#D4AF37]">
              <c.icon size={15} style={{ color: c.color }} /> {c.label}
            </a>
          ))}
        </div>
      </div>
      <div className="mt-20 flex flex-wrap gap-x-6 gap-y-3 text-xs uppercase tracking-[0.2em] text-zinc-500">
        {t.services.map((s) => <span key={s} className="flex items-center gap-2"><span className="text-[#D4AF37]">◆</span>{s}</span>)}
      </div>
    </div>
  </section>
  );
};
